import GiftRedemptionPanel from "./giftRedemptionPanel.container";

export default GiftRedemptionPanel;
